import $ from 'jquery';

export default () => {
  $(document).on('change', '[data-select-size]', (e) => {
    const $item = $(e.currentTarget);
    const url = `/products/${$item.val()}`;

    window.location.href = url;
  });
};